export const EVM_LOGIN_SCOPE = 'openid profile profile.write email phone blockchain.evm.write blockchain.evm'
